import { render, staticRenderFns } from "./echart.vue?vue&type=template&id=0da78d2e&scoped=true&"
import script from "./echart.vue?vue&type=script&lang=ts&"
export * from "./echart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da78d2e",
  null
  
)

export default component.exports